import type { GoodsReview } from 'shared/src/api/goodsService/getGoodsReviews';
import { DeliveryType } from 'shared/src/api/enums/DeliveryType';
import {
  ColorValues,
  Flex,
  IconBrandIconToday,
  Typography,
} from '@banhala/ui-kit';
import { IconBrandIconThirdPL } from '../../../../../../IconBrandIconThirdPL';

export const DeliveryLeadDays: React.FC<{ review: GoodsReview }> = props => {
  const isThirdPLDelivery = props.review.delivery_type === DeliveryType.ThirdPL;
  const josa = isThirdPLDelivery ? '으로' : '로';

  return (
    <Flex
      backgroundColorValue={ColorValues.blue5}
      padding={{ vertical: 8, horizontal: 12 }}
      borderRadius={50}
    >
      {props.review.delivery_lead_days < 2 ? (
        <Flex.Row alignItems={'center'}>
          {isThirdPLDelivery ? (
            <IconBrandIconThirdPL width={49} height={18} />
          ) : (
            <IconBrandIconToday color={ColorValues.lilac40} />
          )}
          <Flex margin={{ top: 2 }}>
            <Typography type={'subtitle3'} color={'bg_slate_primary'}>
              {josa} 발송되었어요 📦
            </Typography>
          </Flex>
        </Flex.Row>
      ) : (
        <Typography type={'subtitle3'} color={'bg_slate_primary'}>
          {props.review.delivery_lead_days}일 후 발송되었어요 📦
        </Typography>
      )}
    </Flex>
  );
};
